import { InputSwitch } from '@/components/Common/InputSwitch/InputSwitch';
import { Calendar } from '@/components/Common/Calendar/Calendar';
import pieceIcon from '@/assets/icons/piece.svg';
import dateIcon from '@/assets/icons/dates.svg';

import { Button, MultiSelectDropDown, TextField } from '@/components/Common';
import {
  IconPosition,
  TextfieldType,
} from '@/components/Common/TextField/TextField.types';
import { FieldError } from 'react-hook-form';
import { useFormConfigExamLogic } from '@/pages/BlankExam/SettingUpTests/useFormConfigExamLogic';

export const FormConfigExam = () => {
  const {
    register,
    handleSubmit,
    errors,
    setValue,
    classes,
    series,
    examConfigs,
    isActive,
    setIsActive,
    selectedClasses,
    selectedSeries,
    examDates,
    onSubmit,
    isCreating,
    isUpdating,
  } = useFormConfigExamLogic();

  return (
    <div className="flex flex-col gap-4 bg-black w-[557px] h-fit">
      <div className="w-[74%] mx-auto flex flex-col gap-4">
        <h1 className="text-white text-xl text-center mt-6 font-bold">
          Configurer l'examen
        </h1>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex justify-between items-center h-[48px] px-5 bg-eerieBlack rounded-lg gap-2 my-3">
            <p className="text-white text-sm">Activer l'examen</p>
            <InputSwitch
              checked={isActive}
              onChange={(e) => {
                setIsActive(e.value);
                setValue('isEnabled', e.value);
              }}
              name="isEnabled"
            />
          </div>
          <div className="mt-5">
            <TextField
              textFieldType={TextfieldType.INPUT}
              placeholder="Saisir la titre"
              className="text-white  border border-solid border-onyx bg-almostBlack"
              name="title"
              register={register('title')}
              helpText={(errors.title as FieldError)?.message}
              errorStyle="text-red-500"
              borderStyle="bg-almostBlack"
              label="Titre de l'examen"
            />
            <TextField
              textFieldType={TextfieldType.TEXTAREA}
              placeholder="Saisir la description"
              textAreaStyle={{ background: '#1D1D1D' }}
              className="text-white  border border-solid border-onyx mt-2"
              name="description"
              register={register('description')}
              helpText={(errors.description as FieldError)?.message}
              errorStyle="text-red-500"
              label="Description de l'examen"
            />
            <div className="flex gap-3 my-5">
              <Calendar
                name="startDate"
                label="Début d'examen"
                helpText={(errors.startDate as FieldError)?.message}
                setValue={setValue}
                dateIcon={dateIcon}
                errorStyle="text-red-500"
                className=" bg-almostBlack text-xs text-center"
                showTime={true}
                hourFormat="24"
                defaultValue={examDates.startDate}
                viewLabel="Date de début"
              />
              <Calendar
                name="endDate"
                label="Fin d'examen"
                helpText={(errors.endDate as FieldError)?.message}
                setValue={setValue}
                dateIcon={dateIcon}
                errorStyle="text-red-500"
                className=" bg-almostBlack text-xs text-center"
                showTime={true}
                hourFormat="24"
                defaultValue={examDates.endDate}
                viewLabel="Date de fin"
              />
            </div>

            <div className="flex gap-3 my-5">
              <Calendar
                name="resultDate"
                label="Délibération"
                helpText={(errors.resultDate as FieldError)?.message}
                setValue={setValue}
                dateIcon={dateIcon}
                errorStyle="text-red-500"
                className=" bg-almostBlack text-xs text-center"
                showTime={true}
                hourFormat="24"
                defaultValue={examDates.resultDate}
                viewLabel="Délibération"
              />
              <Calendar
                name="giftGivingDate"
                label="Distribution cadeaux"
                minDate={new Date()}
                setValue={setValue}
                className="bg-almostBlack text-xs text-center"
                dateIcon={dateIcon}
                helpText={(errors.giftGivingDate as FieldError)?.message}
                errorStyle="text-red-500"
                showTime={true}
                hourFormat="24"
                defaultValue={examDates.giftGivingDate}
                viewLabel="Distribution cadeaux"
              />
            </div>

            <div className="grid grid-cols-2 gap-2 my-5">
              <MultiSelectDropDown
                options={classes || []}
                name="classes"
                setValue={setValue}
                initialSelectedOptions={selectedClasses}
                helpText={(errors.classes as FieldError)?.message}
                errorStyle="text-red-500"
                placeholder="Choix classe"
                selectDropDownStyle={{
                  fontSize: '12px',
                }}
                label="Classe"
              />

              <MultiSelectDropDown
                options={series || []}
                setValue={setValue}
                initialSelectedOptions={selectedSeries}
                helpText={(errors.series as FieldError)?.message}
                errorStyle="text-red-500"
                name="series"
                placeholder="Choix serie"
                multiSelectDropDownStyle="bg-eerieBlack"
                selectDropDownStyle={{
                  fontSize: '12px',
                }}
                label="Série"
              />
            </div>
            <div className="mb-2 mt-5">
              <TextField
                textFieldType={TextfieldType.INPUT}
                className="text-xs text-mediumGrey font-normal"
                placeholder="Points de participation"
                name="pointsToEarn"
                register={register('pointsToEarn')}
                helpText={(errors.pointsToEarn as FieldError)?.message}
                errorStyle="text-red-500"
                icon={<img src={pieceIcon} alt="piece" />}
                iconPosition={IconPosition.LEFT}
                borderStyle="bg-almostBlack px-3"
                label="Points de participation"
              />
            </div>
          </div>
          <div className="w-full flex justify-center items-center pb-[32px] pt-6">
            {examConfigs && examConfigs.length > 0 ? (
              <Button
                className="w-2/3"
                title={isUpdating ? 'Modification...' : 'Modifier'}
                type="submit"
              />
            ) : (
              <Button
                className="w-2/3"
                title={isCreating ? 'Enregistrement...' : 'Enregistrer'}
                type="submit"
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
